import dynamic from "next/dynamic";
import React from "react";
import { usePdfTron } from "lib/contexts/ProjectContexts/PdfTronContext";
import {
  KeyframeViewer,
  useSelectedViewer,
} from "lib/contexts/ProjectContexts/SelectedViewerContext";

const PdfTronViewer = dynamic(
  () => import("components/elements/PdfTronViewer/PdfTronViewer"),
  { ssr: false },
);

const PdfTronHost = () => {
  const pdfTron = usePdfTron();
  const viewerControls = useSelectedViewer();

  function onClose() {
    viewerControls.setViewer(KeyframeViewer.Cesium);
    pdfTron.setFileOptions(null);
  }

  if (!pdfTron) return null;
  return <PdfTronViewer fileOptions={pdfTron.fileOptions} onClose={onClose} />;
};

export default PdfTronHost;
